export default {
	attributes: {
		design: 'basic',
		columns: 2,
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		showImage: false,
		imageSize: 'large',
		image1ShapeFlipX: false,
		image1ShapeFlipY: false,
		image1ShapeStretch: false,
		image2ShapeFlipX: false,
		image2ShapeFlipY: false,
		image2ShapeStretch: false,
		image3ShapeFlipX: false,
		image3ShapeFlipY: false,
		image3ShapeStretch: false,
		showTitle: true,
		title1: 'Title',
		title2: 'Title',
		titleLineHeightUnit: 'em',
		titleTabletLineHeightUnit: 'em',
		titleMobileLineHeightUnit: 'em',
		showPrice: true,
		showPricePrefix: true,
		showPriceSuffix: true,
		pricePrefix1: '$',
		pricePrefix2: '$',
		pricePrefixLineHeightUnit: 'em',
		pricePrefixTabletLineHeightUnit: 'em',
		pricePrefixMobileLineHeightUnit: 'em',
		price1: '9',
		price2: '9',
		priceLineHeightUnit: 'em',
		priceTabletLineHeightUnit: 'em',
		priceMobileLineHeightUnit: 'em',
		priceSuffix1: '.00',
		priceSuffix2: '.00',
		priceSuffixLineHeightUnit: 'em',
		priceSuffixTabletLineHeightUnit: 'em',
		priceSuffixMobileLineHeightUnit: 'em',
		showSubPrice: true,
		subPrice1: 'Sub Price',
		subPrice2: 'Sub Price',
		subPriceLineHeightUnit: 'em',
		subPriceTabletLineHeightUnit: 'em',
		subPriceMobileLineHeightUnit: 'em',
		showButton: true,
		buttonLineHeightUnit: 'em',
		buttonTabletLineHeightUnit: 'em',
		buttonMobileLineHeightUnit: 'em',
		button1LineHeightUnit: 'em',
		button1TabletLineHeightUnit: 'em',
		button1MobileLineHeightUnit: 'em',
		button1Text: 'Button text',
		button1NewTab: false,
		button2LineHeightUnit: 'em',
		button2TabletLineHeightUnit: 'em',
		button2MobileLineHeightUnit: 'em',
		button2Text: 'Button text',
		button2NewTab: false,
		button3LineHeightUnit: 'em',
		button3TabletLineHeightUnit: 'em',
		button3MobileLineHeightUnit: 'em',
		button3NewTab: false,
		showDescription: true,
		description1: 'Description for this block. Place your content here.',
		description2: 'Description for this block. Place your content here.',
		descriptionLineHeightUnit: 'em',
		descriptionTabletLineHeightUnit: 'em',
		descriptionMobileLineHeightUnit: 'em',
		uniqueClass: 'ugb-3cd833d',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
		showBlockTitle: false,
		blockTitleLineHeightUnit: 'em',
		blockTitleTabletLineHeightUnit: 'em',
		blockTitleMobileLineHeightUnit: 'em',
		showBlockDescription: false,
		blockDescriptionLineHeightUnit: 'em',
		blockDescriptionTabletLineHeightUnit: 'em',
		blockDescriptionMobileLineHeightUnit: 'em',
	},
}
